module.exports = __webpack_public_path__ + "media/images/account-black-1b5e43b78306dc878a0967dfec33abe0.svg";